import React from 'react';
import PropTypes from 'prop-types';
import { LEGEND_COLORS } from '../../../reports-constants';
import style from './StudentHeroCard.module.css';
import HeroCard from '../../../../../components/HeroCard/HeroCard';

const StudentHeroCard = ({ unitHighlights, onTabChange }) => {
  const heroTitle = 'Unit Highlights';
  const modalContent = (
    <div>
      <p><b>This student completed # out of # assignments</b> represents the number of assignments in this Unit that the student completed out of the number assigned to them.</p>
      <p><b>This student scored below 60% on # out of # learning objectives</b> represents the number of learning objectives attempted in this Unit where the student answered questions correctly less than 60% of the time on their first attempt.</p>
      <p><b>Unit achievement % on completion assignments (practice/homework)</b> represents the proportion of questions completed by the student across all the Unit’s assignments that define achievement by a student completing the assignment (i.e. practice quizzes and homework assignments where students are granted multiple attempts per question).</p>
      <p><b>Unit achievement % on proficiency assignments (quizzes/tests)</b> represents the proportion of questions that the student got correct across all the Unit’s assignments that define achievement by proficiency (i.e. quizzes and tests where students are granted only one attempt per question).</p>
    </div>
  );

  const nullStateContent = () => (<p>
      None of the unit activities have been assigned.<br />
      Go to the <button role="link" onClick={() => { onTabChange('assignments'); }}>Course Planner</button> tab to set up and manage assignments.
    </p>);

  const heroData = unitHighlights ? [
    {
      title: 'This Student Completed',
      text: unitHighlights.completedAssignments < 0 ? '—' : unitHighlights.completedAssignments,
      color: LEGEND_COLORS.BLACK,
      showBottomText: true,
      bottomText: <p>Out of <b>{unitHighlights.assignments}</b> Assignment{unitHighlights.assignments === 1 ? '' : 's'}</p>,
    },
    {
      title: 'This Student Scored Below 60% on',
      color: LEGEND_COLORS.BLACK,
      text: (unitHighlights.lowScoringLOs < 0 && unitHighlights.notStarted) ? '—' : unitHighlights.lowScoringLOs,
      showBottomText: true,
      bottomText: (unitHighlights.lowScoringLOs < 0 && unitHighlights.notStarted) ? <p>Learning Objectives</p> : <p>Out of <b>{unitHighlights.totalLOs}</b> Learning {unitHighlights.totalLOs === 1 ? 'Objective' : 'Objectives'}</p>,
      className: style.secondColumn,
    },
    {
      title: 'Unit Achievement',
      color: LEGEND_COLORS.BLACK,
      text: unitHighlights.averageCompletion < 0 ? '—' : `${Math.round(unitHighlights.averageCompletion * 100)}%`,
      showBottomText: true,
      bottomText: 'on Completion Assignments (Practice/Homework)',
    },
    {
      title: 'Unit Achievement',
      color: LEGEND_COLORS.BLACK,
      text: unitHighlights.averageProficiency < 0 ? '—' : `${Math.round(unitHighlights.averageProficiency * 100)}%`,
      showBottomText: true,
      bottomText: 'on Proficiency Assignments (Quizzes/Test)',
    },
  ] : [];

  return (<HeroCard
    className={style.qqReportCard}
    heroData={heroData}
    heroTitle={heroTitle}
    modalTitle={heroTitle}
    modalContent={modalContent}
    showNullStateMessage={!unitHighlights}
    nullStateMessage={nullStateContent()}
  />);
};

StudentHeroCard.propTypes = {
  unitHighlights: PropTypes.object,
  onTabChange: PropTypes.func,
};

export default StudentHeroCard;
